import {  HttpFormType ,HttpPayments} from "../Http";
export class StripePaymentAPI {

    public static  createStripeCustomer(input: any){
 
     //     var url = "/formtypes/createStripeAccountByVmCompanyProfileEmailId?emailId=" + input;
   
          var url = "/formtypes/createStripeAccountByVmCompanyProfileUserName?userName=" + input;
   
          if (input === "") {
            return { data: [] };
          }
        
          const resultMethod = HttpFormType.axios()
            .post(url, {
              headers: {
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
              }
            })
            .then(res => {
          //    alert(JSON.stringify(res));
              return res;
            })
            .catch((e: any) => {
          
              return e.response;
            });
          
          return resultMethod;  
      }

      public static  createFrequency(input: any){
        var url = "payments/createFrequency/";
        var obj=JSON.stringify(input);
        
        if (input === "") {
          return { data: [] };
        }
     
        const resultMethod = HttpPayments.axios().post(url, obj,
          {
            headers: {
              'Content-Type': 'application/json',
              "Access-Control-Allow-Origin": "*",
              "Access-Control-Allow-Methods": "*",
              "Access-Control-Allow-Headers": "*"
            }
          })
          .then(res => {
             
            return res;

          }).catch((e: any) => {
      
            return e.response;
          });
        return resultMethod; 
    }


    public static  getAllFrequencyDetails(input: any){
      var url = "payments/getAllFrequencyDetails" ;
     
        if (input === "") {
          return { data: [] };
        }
     
   
        const resultMethod = HttpPayments.axios()
          .get(url,  {
            headers: { 
              'Content-Type': 'application/json',
              'Access-Control-Allow-Origin': '*' ,
              "Access-Control-Allow-Methods": "*",
              "Access-Control-Allow-Headers": "*" 
            }
          })
          .then(res => { 
            return res;
          })
          .catch((e: any) => {
            return e.response;
          });
        
        return resultMethod;  
    }

      public static  saveSubscription(input: any){
        var url = "payments/createSubscription";
        var obj=JSON.stringify(input);
        
        if (input === "") {
          return { data: [] };
        }
     
        const resultMethod = HttpPayments.axios().post(url, obj,
          {
            headers: {
              'Content-Type': 'application/json',
              "Access-Control-Allow-Origin": "*",
              "Access-Control-Allow-Methods": "*",
              "Access-Control-Allow-Headers": "*"
            }
          })
          .then(res => {
             
            return res;

          }).catch((e: any) => {
      
            return e.response;
          });
        return resultMethod; 
    }

    public static  getSubscriptionList(input: any){
      var url = "payments/getAllSubscriptionDetails" ;
     
        if (input === "") {
          return { data: [] };
        }
    
        const resultMethod = HttpPayments.axios()
          .get(url,  {
            headers: {
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": "*",
            }
          })
          .then(res => { 
            return res;
          })
          .catch((e: any) => {
            return e.response;
          });
        
        return resultMethod;  
    }


public static  createCompanyDiscount(input: any){
  
  var url = "payments/createVmCompanyProfileDiscountMapping/"+input.companyCode;
  var obj=JSON.stringify(input);
 
   if (input === "") {
    return { data: [] };
  }

  const resultMethod = HttpPayments.axios().post(url, obj ,{ headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "*",
    "Access-Control-Allow-Headers": "*" 
  } })
    .then(res => {
   
      return res;
    }).catch((e: any) => {
      
      return e.response;
    });
  
  return resultMethod; 
}
/*,
        "Accept": "application/json",
        "Access-Control-Allow-Origin": "http://localhost:3000",
        "Access-Control-Allow-Methods": "*",
        "Access-Control-Allow-Headers": "*",
        "Access-Control-Allow-Credentials":"true" 
        "Response-Type": "blob", 
        */
}